<template>
<div id="sheets-import">
  <div class="row">
    <div class="col-xs-12">
      <h1 class="text-primary">
        <small>Programme National {{ year }}</small>
        <br>
        Import
      </h1>
      <hr>
    </div>
  </div>
  <div class="panel panel-info">
    <div class="panel-heading">
      <div class="form-inline">
        <div class="form-group">
          <div class="input-group">
            <input required
                   ref="input"
                   id="input"
                   tabindex="0"
                   class="form-control"
                   v-model="text"
                   type="text"
                   placeholder="Taper le finess ou le nom"
                   autocomplete="off"/>
          </div>
          <typeahead v-model="establishment"
                     open-on-focus
                     force-select
                     target="#input"
                     :data="establishmentList"
                     item-key="value"/>
        </div>
        <div class="form-group">
          <btn @click="establishment = null" :disabled="establishment == null">
            Effacer
          </btn>
        </div>
      </div>
    </div>
  </div>
  <div class="row" v-if="establishment != null">
    <div class="col-xs-8">
      <h2>{{ selection.establishment.name }}</h2>
      <div class="panel panel-bactADI" v-if="selection.modules.bactADI">
        <div class="panel-heading">
          <div class="panel-title">Bact ADI</div>
        </div>
        <div class="panel-body">
          <importBactADI :surveillance="selection"></importBactADI>
        </div>
      </div>
      <div class="panel panel-reaBactADI" v-if="selection.modules.reaBactADI">
        <div class="panel-heading">
          <div class="panel-title">Réa Bact ADI</div>
        </div>
        <div class="panel-body">
          <importGoutorbe :surveillance="selection"></importGoutorbe>
        </div>
      </div>
      <div class="panel panel-reaInfADI" v-if="selection.modules.reaInfADI">
        <div class="panel-heading">
          <div class="panel-title">Réa Inf ADI</div>
        </div>
        <div class="panel-body">
          <ul>
            <li>
              <importReaInfADI :surveillance="selection"></importReaInfADI>
            </li>
            <li>
              <importReaInfADI3 :surveillance="selection"></importReaInfADI3>
            </li>
            <li>
              <rezo :surveillance="selection"></rezo>
            </li>
          </ul>
        </div>
      </div>
      <div class="panel panel-neoInfADI" v-if="selection.modules.neoInfADI">
        <div class="panel-heading">
          <div class="panel-title">Neo Inf ADI</div>
        </div>
        <div class="panel-body">
          <ul>
            <li>
              <neocat :surveillance="selection"></neocat>
            </li>
            <li>
              <importNeoInfADI :surveillance="selection"></importNeoInfADI>
            </li>
          </ul>
        </div>
      </div>
      <div class="panel panel-diaInfADI" v-if="selection.modules.diaInfADI">
        <div class="panel-heading">
          <div class="panel-title">Dia Inf ADI</div>
        </div>
        <div class="panel-body">
          <importDiaInfADI :surveillance="selection"></importDiaInfADI>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { mapGetters } from 'vuex'
import rezo from '@/components/sheets/import/rezo'
import importBactADI from '@/components/sheets/import/bactadi'
import importDiaInfADI from '@/components/sheets/import/diainfadi'
import importNeoInfADI from '@/components/sheets/import/neoinfadi'
import importGoutorbe from '@/components/sheets/import/goutorbe'
import importReaInfADI from '@/components/sheets/import/reainfadi'
import importReaInfADI3 from '@/components/sheets/import/reainfadi3'
import neocat from '@/components/sheets/import/neocat'

export default {
  name: 'sheets-import',

  data () {
    return {
      establishment: null,
      text: ''
    }
  },

  computed: {
    ...mapGetters({
      getListByName: 'surveillances/listByName'
    }),

    year: function () {
      return this.$route.params.year
    },

    establishmentList: function () {
      return this.getListByName(this.year)
    },

    selection: function () {
      if (this.establishment == null) {
        return null
      }

      return this.establishment.surveillance
    }
  },

  methods: {
  },

  components: {
    'rezo': rezo,
    'importBactADI': importBactADI,
    'importDiaInfADI': importDiaInfADI,
    'importNeoInfADI': importNeoInfADI,
    'importReaInfADI': importReaInfADI,
    'importReaInfADI3': importReaInfADI3,
    'importGoutorbe': importGoutorbe,
    'neocat': neocat
  },

  mounted: function () {
    this.$store.dispatch('surveillances/all', this.year)
  }
}
</script>
<style scoped lang="less">
ul {
    padding: 0rem;
    list-style-type: none;
    li {
        margin-bottom: 0.8rem;
    }
}

</style>
